import getResponsiveWidth from "@wwdev/functions/getResponsiveWidth";
import slick from "slick-carousel";
import './jquery.fixedcontent.min';

function resizeNavigationLine() {
	let navigationExtendedLine = $('.navigation-extended-line');
	if(getResponsiveWidth() > 1300) {
		navigationExtendedLine.show();
		navigationExtendedLine.width(((getResponsiveWidth() - 1300) / 2));
	}
	else {
		navigationExtendedLine.hide();
	}
}

function initializeImageSlider(){
	$('.image-slider').slick({
		'dots': true,
		'infinite': false,
		'prevArrow': '<div class="slick-arrow slick-prev"></div>',
		'nextArrow': '<div class="slick-arrow slick-next"></div>',
		'dotsClass': 'container-fluid mx-auto px-0 px-sm-55 px-md-8 px-xl-0 slick-dots',
		'rows': 0,
		'responsive': [{
			breakpoint: 576,
			settings: {
				dots: false,
				arrows: false
			}
		}]
	});
}

function initializeProjectsSlider() {
	let projectsSlider = $('.projects-slider');
	if(getResponsiveWidth() < 576) {
		if(!projectsSlider.hasClass('slick-initialized')) {
			projectsSlider.slick({
				'infinite': false,
				'prevArrow': '<div class="slick-arrow slick-prev"></div>',
				'nextArrow': '<div class="slick-arrow slick-next"></div>',
				'rows': 0,
				'initialSlide': 1
			});
		}
	}
	else {
		if(projectsSlider.hasClass('slick-initialized')) {
			projectsSlider.slick('unslick');
		}
	}
}

function initializePartnerSlider() {
	let partnerSlider = $('.partner-slider');
	if(getResponsiveWidth() < 576) {
		if(!partnerSlider.hasClass('slick-initialized')) {
			partnerSlider.slick({
				'arrows': false,
				'autoplay': true,
				'slidesToShow': 2,
				'rows': 0
			});
		}
	}
	else {
		if(partnerSlider.hasClass('slick-initialized')) {
			partnerSlider.slick('unslick');
		}
	}
}

$(document).ready(function(){
	$(".js_fixedcontent").fixedcontent({
		marginTop: 0,
		minWidth: 0,
		zIndex: 500
	});

	$(window).scroll(function() {
		setTimeout(function() {
			let headerPositionStyle = $("header").css('position');
			if(headerPositionStyle == 'fixed') {
				if(!$('header').hasClass('fixed')) {
					$('header').addClass('fixed');
					$('.navigation-extended-line').css('top', $("header .navigation").height()-2);
				}
			}
			else {
				$('.navigation-extended-line').css('top', '');
				$('header').removeClass('fixed');
			}
		}, 100);
	});

	resizeNavigationLine();
	initializeImageSlider();
	initializeProjectsSlider();
	initializePartnerSlider();
	$(window).resize(function (){
		resizeNavigationLine();
		initializeProjectsSlider();
		initializePartnerSlider();
	});

	$('.share-links a').each(function() {
		let currentHref = $(this).attr('href');
		currentHref = currentHref.replace('{url}', window.location.href);
		$(this).attr('href', currentHref);
	});

	$('.hamburger').click(function() {
		$(this).toggleClass('is-active');
		$('.mobile-menu-wrapper .mobile-menu').toggleClass('collapsed');
	});
});